import React from "react";
import { Row, Col } from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import SelectRow from "../../components/Select/SelectRow";
import GarageSectionHeader from "../../components/Garage/GarageSectionHeader";
import BranchPhotosPanel from "./BranchPhotosPanel";

/**
 * Photos of one garage. The garage's own photos live under its garage setup
 * page; this screen stays for the direct link and lets a merchant admin pick
 * which garage to look at first.
 */
class MerchantBranchPhotoList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      merchants: [],
      branches: [],
      selectedMerchant: "",
      selectedBranch: "",
      branchName: "",
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const merchantIdFromStorage = sessionStorage.getItem("merchantId");
    const routeState = this.props.location.state || {};
    const { selectedBranch } = this.props.match.params;
    // opened from a garage record, so the garage is fixed for this page
    const branchId =
      selectedBranch && selectedBranch !== ":selectedBranch"
        ? selectedBranch
        : "";
    const selectedMerchant =
      merchantIdFromStorage || routeState.selectedMerchant || "";

    this.setState(
      {
        selectedMerchant,
        selectedBranch: branchId,
        branchName: routeState.branchName || "",
      },
      () => {
        if (selectedMerchant) {
          this.fetchBranches();
        } else {
          this.fetchMerchants();
        }
      }
    );
  }

  fetchMerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
      if (this.state.merchants.length === 1) {
        this.setState({
          selectedMerchant: this.state.merchants[0].value,
        });
        this.fetchBranches();
      }
    }
  };

  fetchBranches = async () => {
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) return;

    const response = await this.engine.getItem(
      `merchants/${selectedMerchant}/branches`
    );
    if (response && response.status === 200) {
      const branches = response.data.items.map((branch) => ({
        value: branch.id,
        label: branch.name || branch.address,
      }));
      this.setState((prev) => ({
        branches,
        branchName: prev.branchName || this.findBranchName(branches, prev),
      }));
    }
  };

  findBranchName(branches, state) {
    const match = branches.find((branch) => branch.value === state.selectedBranch);
    return match ? match.label : "";
  }

  handleMerchantSelect = (event) => {
    const selectedMerchant = event.value;
    if (selectedMerchant !== this.state.selectedMerchant) {
      this.setState(
        { selectedMerchant, selectedBranch: "", branches: [] },
        this.fetchBranches
      );
    }
  };

  handleBranchSelect = (event) => {
    const selectedBranch = event.value;
    this.setState(
      {
        selectedBranch,
        branchName: this.findBranchName(this.state.branches, { selectedBranch }),
      },
      () => {
        this.props.history.push(
          `/admin/merchant-branch/${selectedBranch}/photos`
        );
      }
    );
  };

  render() {
    const {
      merchants,
      branches,
      selectedMerchant,
      selectedBranch,
      branchName,
    } = this.state;
    const isGarageScoped = Boolean(selectedBranch);

    return (
      <div className="content">
        <GarageSectionHeader
          branchId={selectedBranch}
          branchName={branchName}
          merchantId={selectedMerchant}
          active="garage-setup"
          history={this.props.history}
        />
        <Row>
          <Col md="12">
            <BranchPhotosPanel
              key={selectedBranch || "none"}
              branchId={selectedBranch}
              branchName={branchName}
              title={isGarageScoped ? strings.photos : ""}
            >
              {!isGarageScoped &&
                !sessionStorage.getItem("merchantId") &&
                merchants.length !== 1 && (
                  <SelectRow
                    label={strings.merchant}
                    name="selectedMerchant"
                    defaultValue={selectedMerchant}
                    data={merchants}
                    changeInput={this.handleMerchantSelect}
                    placeholder={strings.select}
                  />
                )}
              {!isGarageScoped && (
                <SelectRow
                  key={selectedMerchant || "default"}
                  label={strings.garage}
                  name="selectedBranch"
                  defaultValue={selectedBranch}
                  data={branches}
                  changeInput={this.handleBranchSelect}
                  placeholder={strings.select}
                  viewonly={!selectedMerchant}
                />
              )}
            </BranchPhotosPanel>
          </Col>
        </Row>
      </div>
    );
  }
}

export default MerchantBranchPhotoList;
